import { rankWith, uiTypeIs } from '@jsonforms/core';

export default rankWith(10000, uiTypeIs('RowLayout'));
